import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonIconComponent } from '../../../shared/components/button-icon/button-icon.component';
import {TranslateSafePipe} from '../../../shared/pipes/translation.pipe';

@Component({
  selector: 'app-info-card',
  imports: [
    ButtonIconComponent,
    RouterLink,
    TranslateSafePipe,
  ],
  templateUrl: './info-card.component.html',
  styleUrl: './info-card.component.css',
})
export class InfoCardComponent {
  @Input()
  public title!: string;

  @Input()
  public count!: string;

  @Input()
  public icon!: string;

  @Input()
  public text!: string;

  @Input()
  public activeAlarmText!: {
    critical: number,
    high: number,
    warning: number,
    info: number
  };

  @Input()
  public activeDevices!: string;

  @Input()
  public indicator: string = '';

  @Input()
  public iconClick: () => void = () => {};

  @Input()
  public routerLink: string | string[] = [];
}
